import React, { useState } from 'react';
import SmsService from '@/services/SmsService';

const SendSmsComponent = () => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [trackingNumber, setTrackingNumber] = useState('');
    const [shipmentStatus, setShipmentStatus] = useState('Pending');
    const [result, setResult] = useState('');

    const handleSend = async () => {
        try {
            const message = await SmsService.sendSms(phoneNumber, trackingNumber, shipmentStatus);
            setResult(message);
        } catch (error) {
            setResult(`❌ ${error}`);
        }
    };

    return (
        <div className="p-4 space-y-2">
            <input
                type="text"
                placeholder="Phone number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                className="border p-2 w-full"
            />
            <input
                type="text"
                placeholder="Tracking number"
                value={trackingNumber}
                onChange={(e) => setTrackingNumber(e.target.value)}
                className="border p-2 w-full"
            />
            <select
                value={shipmentStatus}
                onChange={(e) => setShipmentStatus(e.target.value)}
                className="border p-2 w-full"
            >
                <option value="Pending">Pending</option>
                <option value="InTransit">InTransit</option>
                <option value="Delivered">Delivered</option>
                <option value="Cancelled">Cancelled</option>
            </select>
            <button onClick={handleSend} className="bg-blue-600 text-white px-4 py-2 rounded">
                Send SMS
            </button>

            {result && <p className="mt-4">{result}</p>}
        </div>
    );
};

export default SendSmsComponent;
